import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { VerificationModalPageComponent } from '../modals/verification-modal/verification-modal.page';
import { config as conf } from 'src/app/config';

@Injectable({
    providedIn: 'root'
})
export class ModalService {
    VerificationModalPage: HTMLIonModalElement
    emailVerification: HTMLIonModalElement
    emailActivation: HTMLIonModalElement
    forgotEmailVerification: HTMLIonModalElement

    constructor(private modalController: ModalController) {
        this.init()
    }

    async init() {
        this.VerificationModalPage = await this.modalController.create({
            component: VerificationModalPageComponent,
            cssClass: 'verification-modal',
            componentProps: {
                data: conf.MODAL_VERIFICATION_DATA.message
            },
            backdropDismiss: false
        });

        this.emailVerification = await this.modalController.create({
            component: VerificationModalPageComponent,
            cssClass: 'verification-modal',
            componentProps: {
                data: conf.MODAL_VERIFICATION_DATA.mail
            },
            backdropDismiss: false
        });

        this.emailActivation = await this.modalController.create({
            component: VerificationModalPageComponent,
            cssClass: 'verification-modal',
            componentProps: {
                data: conf.MODAL_VERIFICATION_DATA.activate
            },
            backdropDismiss: false
        });

        this.forgotEmailVerification = await this.modalController.create({
            component: VerificationModalPageComponent,
            cssClass: 'verification-modal',
            componentProps: {
                data: conf.MODAL_VERIFICATION_DATA.forget_password
            },
            backdropDismiss: false
        });
    }

    modals = {
        VERIFICATION: () => this.VerificationModalPage.present(),
        'EMAIL-VERIFICATION': () => this.emailVerification.present(),
        'EMAIL-ACTIVATION': () => this.emailActivation.present(),
        'FORGET-EMAIL-VERIFICATION': () => this.forgotEmailVerification.present(),
        default: () => null
    }

    /**
   * Opens the modal based on a modal name
   * @returns
   */
    async openModal(modalName: string) {
        const func = this.modals[modalName] || this.modals.default

        return func()
    }

    /**
   * Closes a modal
   */
    async closeModal() {
        await this.modalController.dismiss();
    }
}
